import React, { useEffect } from "react";
import InterestIcon from "../Assets/Images/interestIcon.svg";
import CreditHistory from "../Assets/Images/credit-history-icon.svg";
import AccountIcon from "../Assets/Images/account-icon.svg";
import Macbook from "../Assets/Images/agent-portal-icon.svg";
import "../Assets/Styles/NavBar.css"; // Make sure the CSS file is correctly imported
import { Link } from "react-router-dom";

const ProductsModal = ({ isOpen, isScrolled, onClose }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => document.body.classList.remove("modal-open");
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className={`fixed inset-0 z-30 ${
        isOpen ? "modal-overlay active" : "modal-overlay"
      } flex justify-center `}
    >
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/20 " onClick={onClose} />

      {/* Modal Content */}
      <div
        className={`relative overflow-hidden bg-white w-full shadow-lg transition-transform transform modal-slide ${
          isOpen ? "active" : ""
        } lg:h-[350px] ${
          isScrolled ? "mt-[72px]" : "mt-[122px]"
        } pt-[0px]  `}
      >
        <div className="container h-[100%] flex max-w-full lg:max-w-full [@media(min-width:1920px)]:max-w-[1800px] mx-auto">
          {/* Left Column - Our Plans */}
          <div className="ourplansdiv flex flex-col justify-center items-start w-3/5 p-16 [@media(min-width:1920px)]:pl-[4px]">
            {/* <Link to="/">
              <div className="group cursor-pointer mb-[2rem] min-w-[280px]">
                <div className="flex items-center space-x-4">
                  <img className="AFIcons" src={InterestIcon} alt="" />
                  <div className="flex items-center space-x-2">
                    <span className="Aftexts font-medium">
                      Links of Interests
                    </span>
                    <svg
                      className="w-4 h-4 transform group-hover:translate-x-1 transition-transform"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M5 12h14m-7-7l7 7-7 7"
                        stroke="currentColor"
                        fill="none"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </Link> */}

            <Link to="/credited-interest-rate">
              <div className="group cursor-pointer mt-[1.5rem] mb-[1.5rem] min-w-[280px]">
                <div className="flex items-center space-x-4">
                  <img className="AFIcons" src={CreditHistory} alt="" />
                  <div className="flex items-center space-x-2">
                    <span className=" Aftexts font-medium">
                      Credit Interest Rate
                    </span>
                    <svg
                      className="w-4 h-4 transform group-hover:translate-x-1 transition-transform"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M5 12h14m-7-7l7 7-7 7"
                        stroke="currentColor"
                        fill="none"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </Link>

            <Link to="https://secured.afibl.com/" target="_blank">
              <div className="group cursor-pointer mt-[1.5rem] mb-[1.5rem] min-w-[280px]">
                <div className="flex items-center space-x-4">
                  <img className="AFIcons" src={AccountIcon} alt="" />
                  <div className="flex items-center space-x-2">
                    <span className="Aftexts font-medium">Create Account</span>
                    <svg
                      className="w-4 h-4 transform group-hover:translate-x-1 transition-transform"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M5 12h14m-7-7l7 7-7 7"
                        stroke="currentColor"
                        fill="none"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </Link>
          </div>

          {/* Right Column - Insights */}
          <div className="rightcolmaindiv bg-[#F7F6F2] pt-8 pb-8 flex justify-center items-center w-2/5">
            <div className="pl-16 pr-16">
              <div className="flex flex-col  ">
                {/* <img
                  className="w-[102px] h-[102px] self-center mb-5"
                  src={Macbook}
                  alt="Health Plan Comparison"
                /> */}
                <h3 className="text-gray-500 font-medium">
                  <Link
                    to="https://secured.afibl.com/"
                    target="_blank"
                    className="flex flex-row items-center justify-center text-[#0D4248] font-bold text-[20px]"
                  >
                    Access to our portal{" "}
                    <svg
                      className="w-4 h-4 transform group-hover:translate-x-1 transition-transform ml-2"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M5 12h14m-7-7l7 7-7 7"
                        stroke="currentColor"
                        fill="none"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </Link>
                </h3>
                <p className="text-[#0D4248] text-center mt-2 max-w-[280px] discovertext relative">
                  Enter our portal to start a quotation, manage account or
                  download product information.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductsModal;
